export function isTrue(value: boolean | string) {
    return value === true || value === 'true'
  }